import { type ReactNode } from "react"

import type { SX } from "../../theme"
import { Icon } from "../Icon"
import { Text } from "../Text"
import styles from "./FormFieldError.module.css"

type FormFieldErrorProps = {
  children: ReactNode
  sx: SX
}

export function FormFieldError(props: FormFieldErrorProps) {
  const { children, sx } = props

  return (
    <Text component="span" color="tomato11" sx={sx}>
      <Icon
        className={styles.icon}
        name="alert"
        size="small"
        color="tomato11"
      />{" "}
      {children}
    </Text>
  )
}
